import { createSlice } from "@reduxjs/toolkit";
import { userLoggedOut } from "./AuthSlice";

const initialState = {
  providers: {
    providers: [],
    params: {},
  },
  providerPatients: {
    patients: [],
    params: {},
  },
};

export const ProviderSlice = createSlice({
  name: "ProviderSlice",
  initialState,
  reducers: {
    setProviders: (state, { payload }) => {
      state.providers = payload;
    },
    setProviderPatients: (state, { payload }) => {
      state.providerPatients = payload;
    },
    setDeleteProvider: (state, { payload }) => {
      state.providers.providers = state.providers.providers.filter(
        (ls) => ls._id !== payload._id
      );
    },
    extraReducers: (builder) => {
      builder.addCase(userLoggedOut, () => initialState);
    },
  },
});

export const { setProviders, setProviderPatients, setDeleteProvider } =
  ProviderSlice.actions;
export default ProviderSlice.reducer;
